import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatPlaceName } from '@aviv_price-pages/brand';
import { Box, useBreakpointValue } from '@gemini/core';
import { Card, Link } from '@gemini/ui';
import { BuildingIcon } from '@/assets/icons/BuildingIcon';
import { HouseIcon } from '@/assets/icons/HouseIcon';
import { useShellTranslation } from '@/hooks/useShellTranslation/useShellTranslation';
const OffersSalesBlock = ({ pricePageContext, serpLinks }) => {
    const { t } = useShellTranslation();
    const useRowLayoutSingleCard = useBreakpointValue({
        base: false,
        sm: true,
        md: true,
        lg: false,
        xl: true,
    });
    const houseUrl = serpLinks?.buyHouse?.url;
    const apartmentUrl = serpLinks?.buyApartment?.url;
    if (!houseUrl && !apartmentUrl)
        return null;
    const formattedPlaceName = formatPlaceName(serpLinks.placeUsedForLinks, { isShortName: true });
    const isSingleCardLayout = (houseUrl && !apartmentUrl) || (!houseUrl && apartmentUrl);
    const useRowLayout = useRowLayoutSingleCard && isSingleCardLayout;
    const renderCard = ({ icon, titleKey, value, url, titleAttrKey, linkLabelKey, }) => (_jsx(Box, { flexGrow: 1, width: "100%", children: _jsx(Card, { borderRadius: "16", children: _jsxs(Box, { display: "flex", flexDirection: useRowLayout ? 'row' : 'column', alignItems: useRowLayout ? 'center' : 'flex-start', justifyContent: "space-between", gap: "spacing.8", padding: "spacing.16", children: [_jsxs(Box, { display: "flex", flexDirection: "column", gap: "spacing.8", children: [icon, _jsx(Box, { typography: "typography.body.12.regular", color: "color.content.light.default", children: t(titleKey) }), _jsx(Box, { typography: "typography.headline.32.bold", children: value })] }), _jsx(Link, { href: `${url}?m=price_map_${pricePageContext.place.type}_classified_search_results`, title: t(titleAttrKey, {
                            replace: { place: formattedPlaceName },
                        }), isExternal: true, children: t(linkLabelKey) })] }) }) }));
    return (_jsxs(Box, { marginTop: "spacing.48", children: [_jsx(Box, { as: "h2", typography: "typography.headline.20.bold", children: t('serp_block.title', { replace: { place: formattedPlaceName } }) }), _jsxs(Box, { display: "flex", gap: "spacing.16", children: [houseUrl &&
                        renderCard({
                            icon: _jsx(HouseIcon, { width: "32px" }),
                            titleKey: 'serp_block.title_house',
                            value: serpLinks.buyHouse.classifiedCount,
                            url: houseUrl,
                            titleAttrKey: 'serp_block.title_attribute_house',
                            linkLabelKey: 'serp_block.link_house',
                        }), apartmentUrl &&
                        renderCard({
                            icon: _jsx(BuildingIcon, { width: "32px" }),
                            titleKey: 'serp_block.title_apartment',
                            value: serpLinks.buyApartment.classifiedCount,
                            url: apartmentUrl,
                            titleAttrKey: 'serp_block.title_attribute_apartment',
                            linkLabelKey: 'serp_block.link_apartment',
                        })] })] }));
};
export default OffersSalesBlock;
